export const modifyPreviewAssets = (arr) =>
  arr?.map((el) => ({
    ...el,
    rental: {
      ...el.rental,
      rentalStatus: { ...el.rental.rentalStatus, id: el.rental.rentalStatus.name }
    }
  })) || [];
